import axios from 'axios';

const state = {
  user: null,
  isAuthenticated: false,
  authCheckDone: false,
};

const getters = {
  isAuthenticated: (state) => state.isAuthenticated,
  currentUser: (state) => state.user,
  authCheckDone: (state) => state.authCheckDone,
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
    state.isAuthenticated = !!user;
  },
  SET_AUTH_CHECK_DONE(state, done) {
    state.authCheckDone = done;
  },
  CLEAR_AUTH(state) {
    state.user = null;
    state.isAuthenticated = false;
  },
};

const actions = {
  async login({ commit }, credentials) {
    try {
      const response = await axios.post('/api/auth/login', credentials, {
        withCredentials: true,
      });
      if (response.data.success && response.data.user) {
        commit('SET_USER', response.data.user);
      return { success: true };
      }
      return {
        success: false,
        message: response.data.message || 'Login failed',
      };
    } catch (error) {
      commit('CLEAR_AUTH');
      return {
        success: false,
        message: error.response?.data?.message || 'Login failed',
      };
    }
  },

  async logout({ commit }) {
    try {
      await axios.post('/api/auth/logout', {}, { withCredentials: true });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      commit('CLEAR_AUTH');
    }
  },

  async checkAuth({ commit }) {
    try {
      const response = await axios.get('/api/auth/me', {
        withCredentials: true,
      });
      if (response.data.success && response.data.user) {
      commit('SET_USER', response.data.user);
        commit('SET_AUTH_CHECK_DONE', true);
      return { success: true };
      }
      commit('CLEAR_AUTH');
      commit('SET_AUTH_CHECK_DONE', true);
      return { success: false };
    } catch (error) {
      commit('CLEAR_AUTH');
      commit('SET_AUTH_CHECK_DONE', true);
      return { success: false };
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

